<div class="portlet light">
  <storever-header-page [icon]="'far fa-shopping-cart'"
                        [title]="'DASHBOARD_ORDERS_MAIN_TITLE'"
                        [isEdit]="false"
                        [buttonTitle]="'IMPORT_EXCEL_FILE'"
                        [buttonIcon]="'fal fa-file-excel fa-lg'"
                        (_action)="export($event)" >
  </storever-header-page>
  <div class="portlet-body">
    <label class="col-md-1" style="top:10px">Period</label>
    <div class="fa-pull-left col-xs-12 col-md-3 form-group" >

      <input type="text"
             placeholder="Period"
             class="form-control"
             (bsValueChange)="applyFilter($event)"
             [(ngModel)]="defaultValue"
             [minDate]="minDate"
             [bsConfig]="{ ranges: ranges , dateInputFormat: 'DD/MM/YYYY'}"
             bsDaterangepicker>
    </div>
    <div class="offset-md-4  col-xs-12 col-md-6 form-group" style=" top: -3px;">
    <storever-datatable-header-btn
      [btnList]="btnList"
      [selectedBtn]="selectedBtn"
      [smallBtn]="true"
      (btnListChange)="updateList($event)"
    ></storever-datatable-header-btn>
    </div>
    <storever-highcharts-chart
      [Highcharts] = "highchartsRef"
      [options] = "chartOptions"
      [(update)]="updateFromInput"
      [oneToOne]="true"
      style = "width: 100%; height: 400px; display: block;">
    </storever-highcharts-chart>
    <h4 class="center" translate>Orders Counter Table</h4>
    <table *ngIf="dataSum; else noData" class="table table-bordered table-condensed">
      <thead>
      <tr>
        <th translate></th>
        <th translate>DASHBOARD_ORDERS_DEPLOY_NUMBER</th>
        <th translate>DASHBOARD_ORDERS_EXCHANGE_NUMBER</th>
        <th translate>DASHBOARD_ORDERS_SUM</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of dataSum">
        <td>{{ dateFormat(item.date)  }}</td>
        <td>{{ item.deploy }}</td>
        <td>{{ item.exchange }}</td>
        <td>{{ item.sum }}</td>
      </tr>
      <tr class="total-row">
        <td>Total</td>
        <td>{{ totalDeploy }}</td>
        <td>{{ totalExchange }}</td>
        <td>{{ totalSum | number: '1.0-2':'be' }}</td>
      </tr>
      </tbody>
    </table>
    <ng-template #noData>
      <div class="no-data" translate>GENERIC_NO_DATA</div>
    </ng-template>

  </div>

</div>
